// Global Apex Markets brand logo, used everywhere in the admin console.
// Bundled transparent PNGs (not the white label's uploaded logo URLs), so the
// globe icon, "GLOBAL APEX" and "MARKETS" stay crisp on any background.
import logoOnDark from "../Images/globalapex-logo-dark.png"; // white wordmark, for dark surfaces
import logoOnLight from "../Images/globalapex-logo-light.png"; // navy wordmark, for light surfaces
import brandMark from "../Images/globalapex-mark.png"; // globe icon only, for compact slots

export const BRAND_NAME = "Global Apex Markets";

export const BRAND_LOGO = { onDark: logoOnDark, onLight: logoOnLight, mark: brandMark };

// Full logo for the current colour mode ("dark" | "light" from next-themes)
export const getBrandLogo = (resolvedTheme) => (resolvedTheme === "dark" ? logoOnDark : logoOnLight);
